import { render, staticRenderFns } from "./Lgx328518181243060224.vue?vue&type=template&id=24ab5510&"
import script from "./Lgx328518181243060224.vue?vue&type=script&lang=js&"
export * from "./Lgx328518181243060224.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports